import { RenderPS } from './RenderPS';
import { RenderPD } from './RenderPD';
import { RenderFR } from './RenderFR';
import { RenderOR } from './RenderOR';
import { RenderMLM } from './RenderMLM';
import { RenderMLF } from './RenderMLF';
import { RenderTubetto } from './RenderTubetto';
import { RenderFaston2_8 } from './RenderFaston2_8';
import { RenderFaston6_3 } from './RenderFaston6_3';
import { RenderFastonCovered4_8 } from './RenderFastonCovered4_8';
import { RenderFastonCovered6_3 } from './RenderFastonCovered6_3';
import { RenderFastonSquadra } from './RenderFastonSquadra';

export const TerminalRenderers = {
  PS: RenderPS,
  PD: RenderPD,
  FR: RenderFR,
  MLM: RenderMLM,
  MLF: RenderMLF,
  TR: RenderTubetto,
  FB: RenderFR,
  FY: RenderFR,
  OR: RenderOR,
  OB: RenderOR,
  OY: RenderOR,
  TB: RenderTubetto,
  TY: RenderTubetto,
  FSR2_8: RenderFaston2_8,
  FSR4_8: RenderFaston6_3,
  FSR6_3: RenderFaston6_3, 
  FC4_8: RenderFastonCovered4_8,
  FC6_3: RenderFastonCovered6_3,
  FAS: RenderFastonSquadra 
};

export { RenderPS, RenderPD, RenderFR, RenderOR, RenderMLM, RenderMLF, RenderTubetto, RenderFaston2_8, RenderFaston6_3, RenderFastonCovered4_8, RenderFastonCovered6_3, RenderFastonSquadra };
